import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { getDataLayer } from 'app/selectors/AnalyticsSelector';
import DataLayer from './DataLayer';

/** @extends React.Component */
export class DataLayerContainer extends BcReactComponent {
  render() {
    return <DataLayer {...this.props} />;
  }
}

DataLayerContainer.propTypes = {
  dataLayer: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => ({
  dataLayer: getDataLayer(state)
});

export default connect(mapStateToProps)(DataLayerContainer);
